// extracted by mini-css-extract-plugin
export default {"actions":"styles_actions__UiKcS","actionButton":"styles_actionButton__OrZXT","spin":"styles_spin__Sy28b"};